
export const GET_USERNAME= "GET_USERNAME";
export const DELETE_USERNAME = "DELETE_USERNAME";